import React from "react";
import moment from "moment";
import { Col, Row } from "antd";
import PickupTable from "./OrdersAdmin/OrderSummary/PickupTable";
import CustomerTable from "./OrdersAdmin/OrderSummary/CustomerTable";
import ProductTable from "./OrdersAdmin/OrderSummary/ProductTable";
import ProgressCard from "./OrdersAdmin/OrderSummary/progressCard";
import Indicator from "./StatusIndicator/Indicator";

const Card = (content) => <div className="card-summary">{content}</div>;

const MyPendingOrders = (props) => {
  const { orderDetailsData } = props;

  // 👉 NEW: Helper function to calculate exact order total applying Promo logic
  const calculateCorrectOrderTotal = (orderData) => {
    // If no items array exists, fallback to the backend's root amount
    if (!orderData?.items || orderData.items.length === 0) {
      return Number(orderData?.amount) || 0;
    }

    let calculatedTotal = 0;

    orderData.items.forEach((item) => {
      const product = item.product;
      const qty = Number(item.qty) || 0;

      // Check if this specific item was a promo product
      if (
        product &&
        (product.is_promo_product === true || product.is_promo_product === 1)
      ) {
        const unit = Number(product.unit) || 1;
        const promoAmount = Number(product.promo_amount) || 0;

        if (unit > 0) {
          // Calculate based on bundle price
          calculatedTotal += (qty / unit) * promoAmount;
        }
      } else {
        // Standard Calculation using item amount instead of product amount, as prices might have changed since order creation
        calculatedTotal +=
          (Number(item.amount) || Number(product?.amount) || 0) * qty;
      }
    });

    return calculatedTotal;
  };

  // 👉 Calculate the correct total here
  const calculatedTotalAmount = orderDetailsData?.items?.[0]?.product
    ?.is_promo_product
    ? orderDetailsData.amount
    : calculateCorrectOrderTotal(orderDetailsData);
  console.log("Calculated Total Amount:", orderDetailsData);

  const PaymentDetails = [
    {
      subtotal: calculatedTotalAmount, // 👉 Use the calculated amount
      discount: 0,
      total: calculatedTotalAmount, // 👉 Use the calculated amount
    },
  ];

  const OrderStatusDetails = {
    orderstatusid: orderDetailsData?.order_status_id,
    orderenddate: orderDetailsData?.end_date,
  };

  const OrderPickupLocation = {
    location: orderDetailsData?.location?.name,
  };

  return (
    <div className="card-summary">
      <div className="d-flex justify-content-between">
        <p className="d-inline-flex align-items-center gap-3">
          <span className="order-id-title">Order #{orderDetailsData?.id}</span>{" "}
          •
          <span className="order-title-info">
            {moment(orderDetailsData?.start_date).format("MMM Do YYYY")} {" , "}
            {moment(orderDetailsData?.start_date).format("h:mm A")}
          </span>{" "}
          •
          <span className="order-title-info">
            {orderDetailsData?.items?.length} Products
          </span>{" "}
          •
          <span className="order-title-info">
            Transaction Ref: {orderDetailsData?.reference}
          </span>{" "}
        </p>
        <span>
          <Indicator
            status={orderDetailsData?.order_status_id === 6 ? "red" : "green"}
            name={
              orderDetailsData?.order_status?.name === "Initial"
                ? "In Progress"
                : orderDetailsData?.order_status?.name
            }
          />
        </span>
      </div>
      <div>
        <div className="d-flex gap-4 flex-column">
          <Row gutter={[16, 16]} align="top">
            <Col lg={16} sm={24} md={24}>
              {Card(<ProgressCard details={OrderStatusDetails} />)}
            </Col>
            <Col lg={8} sm={24} md={24} style={{ width: "100%" }}>
              {Card(<CustomerTable details={PaymentDetails} />)}
              <div>{Card(<PickupTable details={OrderPickupLocation} />)}</div>
            </Col>
          </Row>
          <Row gutter={[16, 16]} align="top">
            <Col lg={24} sm={24} md={24}>
              {Card(<ProductTable data={orderDetailsData?.items} />)}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default MyPendingOrders;
